import gql from 'graphql-tag';
import { apollo } from 'src/features';

const mutation = gql`
mutation CloseActivityByOperator($activityId: ID!) {
  closeOperatorActivity(activityId: $activityId)
}`;

function closeActivityByOperator(activityId) {
  return apollo.client.mutate({
    variables: {
      activityId,
    },
    mutation,
  }).then((res) => {
    if (res.data.closeOperatorActivity) {
      return {
        id: activityId,
        state: 'closed',
      };
    }
    throw res;
  });
}

export default closeActivityByOperator;
